import { createContext } from "react";

export const AIS_WORKER_VERSION = createContext<string>('');